import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ConfigurationService } from './configuration.service';
// declare existence of object ATInternet
declare let ATInternet;
type Tag = any;

@Injectable({
  providedIn: 'root'
})
export class AtInternetService {

  private tag: Tag;

  private readonly PAGE_NAME: string = environment.atInternetPageName;

  private serviceReadySubject: Subject<boolean> = new BehaviorSubject(false);
  public serviceReady$: Observable<boolean> = this.serviceReadySubject.asObservable();

  constructor(private configurationService: ConfigurationService) {
    this.getTagSite().subscribe(
      tagSite => {
        console.debug(`load xiti script with tag site [${tagSite}]`)
        this.loadScript(tagSite)
      }
    );
  }

  private getTagSite(): Observable<string> {
    return this.configurationService.configuration$.pipe(
      map(configuration => configuration.atInternetTagSite),
      catchError(err => of("")),
    );
  }

  private loadScript(tagSite: string) {
    const scriptElt: HTMLScriptElement = document.createElement('script');
    scriptElt.onerror = this.loadError;
    scriptElt.onload = (ev: Event) => this.scriptLoaded(ev);
    document.head.appendChild(scriptElt);
    scriptElt.src = `//tag.aticdn.net/${tagSite}/smarttag.js`;
  }

  private loadError(error: Event | string): void {
    console.error('cannot load xiti script', error);
  }

  private scriptLoaded(ev: Event): void {
    console.debug('xiti script loaded', ev);
    this.initTag();
    this.serviceReadySubject.next(true);
  }

  private initTag(): void {
    this.tag = new ATInternet.Tracker.Tag();
    const props: AtInternetProps = {
      page: environment.atInternetPageName,
    }
    this.tag.setProps(props, false);
    console.debug(this.tag);
  }

  generatePage(tag, pageName, name){
    try{
      tag.setProps({
        page: pageName,
      }, true);
      tag.page.set({
        name: name
      });
      tag.dispatch();
    } catch(e){
    }
  }
  generateClickAction(tag, click, click_chapter1){
    try{
      tag.events.send('click.action', {
        click: click,
        click_chapter1:  click_chapter1
      });
    }catch(e){
    }
  }
  generateClickExit(tag, click, click_chapter1){
    try{
      tag.events.send('click.exit', {
        click: click,
        click_chapter1:  click_chapter1
      });
    }catch(e){
    }
  }
  // tag for openning map
  generateClickOpenMap(tag, click, click_chapter1, scgp_id_colis){
    try{
      tag.events.send('click.action', {
        'click': click,
        'click_chapter1': click_chapter1,
        'scgp_id_colis': scgp_id_colis
      });
    }catch(e){
    }
  }
  // tag for closing map
  generateClickCloseMap(tag, click, click_chapter1, scgp_carte_livraison_temps, scgp_id_colis){
    try{
      tag.events.send('click.action', {
        'click': click,
        'click_chapter1':  click_chapter1,
        'scgp_carte_livraison_temps': scgp_carte_livraison_temps,
        'scgp_id_colis': scgp_id_colis
      });
    }catch(e){
    }
  }
}

interface AtInternetProps {
  disableCookie?: boolean;
  application?: string;
  page_chapter1?: string;
  page_chapter2?: string;
  page?: string;
  numero_colis?: string;
  compte_client_scgp?: string;
  etape_suivi_colis?: string
 }
